import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { completeEndpoint, EndpointPart } from '../../core/global';
import { DateFormatPipe } from '../../pipes/date-format.pipe';
import { EndpointService } from '../endpoint/endpoint.service';

import { AmountModel } from './model/amount-model';
import { CurrencyRateModel } from './model/currency-rate-model';

@Injectable({
  providedIn: 'root',
})
export class CurrencyService {
  private readonly http = inject(HttpClient);
  private readonly endpointService = inject(EndpointService);
  private readonly dateFormatPipe = inject(DateFormatPipe);

  public getCurrentCurrencyRate(selectedCurrency: string, currencyRateDate: Date): Observable<CurrencyRateModel> {
    const pathParams: Map<string, string> = new Map();
    pathParams.set('currencyKey', selectedCurrency);
    pathParams.set('currencyRateDate', this.dateFormatPipe.transformDateToGlobalFormat(currencyRateDate));

    const url: string = this.endpointService.getEndpointUrl(
      completeEndpoint(EndpointPart.GET_CURRENT_CURRENCY_RATE),
      pathParams,
    );
    return this.http.get<CurrencyRateModel>(url);
  }

  /**
   * Convert amount (amount)
   * from currency (amountCurrencyUnit)
   * to currency (amountCurrencyUnitToTransform)
   * by exchange rate from date (currencyUnitToTransformRateDate)
   * @param amount
   * @param amountCurrencyUnit
   * @param amountCurrencyUnitToTransform
   * @param currencyUnitToTransformRateDate
   */
  public convertAmountToSpecificCurrency(
    amount: number,
    amountCurrencyUnit: string,
    amountCurrencyUnitToTransform: string,
    currencyUnitToTransformRateDate: Date,
  ): Observable<AmountModel> {
    const pathParams: Map<string, number | string> = new Map();
    pathParams.set('amount', amount);
    pathParams.set('amountCurrencyUnit', amountCurrencyUnit);
    pathParams.set('amountCurrencyUnitToTransform', amountCurrencyUnitToTransform);
    pathParams.set('currencyUnitToTransformRateDate', new Date(currencyUnitToTransformRateDate).toISOString());

    const url: string = this.endpointService.getEndpointUrl(
      completeEndpoint(EndpointPart.GET_CURRENCY_CONVERT_AMOUNT_TO_SPECIFIC_CURRENCY),
      pathParams,
    );
    return this.http.get<AmountModel>(url);
  }
}
